import { API } from "../api";
const BASE_URL = "/cooperatives/birthday_message";
const BIRTHDAY_URL = "/cooperatives/automated_birthdays";
const SETTINGS_URL = "/cooperatives/settings/birthday";
const LOGS_URL = "/cooperatives/birthday_logs";

const authomatedBirthdayExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getBirthdayMessages: builder.query({
      query: (page = 1) => `${BASE_URL}/pull?guard=staff&page=${page}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: (result, error, arg) => [
        { type: "AutoBirthday", id: "LIST" },
      ],
    }),
    createBirthdayMessage: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/add?guard=staff`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: [{ type: "AutoBirthday", id: "LIST" }],
    }),
    updateBirthdayMessage: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/${body.id}/edit?guard=staff`,
        method: "PATCH",
        body: body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "AutoBirthday", id: "LIST" },
        { type: "AutoBirthday", id: arg.id },
      ],
    }),
    toggleBirthdayMessageStatus: builder.mutation({
      query: (id) => ({
        url: `${BASE_URL}/${id}/toggle-active?guard=staff`,
        method: "PUT",
      }),
      invalidatesTags: [{ type: "AutoBirthday", id: "LIST" }],
    }),
    sendAdminManualWish: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/manual-wish?guard=staff`,
        method: "POST",
        body,
      }),
      // Invalidate relevant tags across both staff and member views
      invalidatesTags: ["BirthdayLogs", "ReceivedWishes"],
    }),
    getBirthdays: builder.query({
      query: (page = 1) => `${BIRTHDAY_URL}?guard=staff&page=${page}`,
      transformResponse: (responseData) => responseData.data,
    }),
    getStaffReceivedWishes: builder.query({
      query: (page = 1) => `${BIRTHDAY_URL}/received-wishes?guard=staff&page=${page}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: ["ReceivedWishes"],
    }),
    // Settings Endpoints
    getBirthdaySettings: builder.query({
      query: () => `${SETTINGS_URL}?guard=staff`,
      transformResponse: (responseData) => responseData.data,
      providesTags: ["BirthdaySettings"],
    }),
    updateBirthdaySettings: builder.mutation({
      query: (body) => ({
        url: `${SETTINGS_URL}/update?guard=staff`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["BirthdaySettings"],
    }),
    // Logs Endpoints
    getBirthdayLogs: builder.query({
      query: ({ page = 1, from_date, to_date, status, recipient_type, search }) => {
        let url = `${LOGS_URL}?guard=staff&page=${page}`;
        if (from_date) url += `&from_date=${from_date}`;
        if (to_date) url += `&to_date=${to_date}`;
        if (status) url += `&status=${status}`;
        if (recipient_type) url += `&recipient_type=${recipient_type}`;
        if (search) url += `&search=${search}`;
        return url;
      },
      transformResponse: (responseData) => responseData.data,
    }),
  }),
});

export const {
  useGetBirthdayMessagesQuery,
  useGetBirthdaysQuery,
  useGetStaffReceivedWishesQuery,
  useCreateBirthdayMessageMutation,
  useUpdateBirthdayMessageMutation,
  useToggleBirthdayMessageStatusMutation,
  useSendAdminManualWishMutation,
  useGetBirthdaySettingsQuery,
  useUpdateBirthdaySettingsMutation,
  useGetBirthdayLogsQuery,
} = authomatedBirthdayExtendedApi;
